import React, { Component } from "react";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";

export default class NavbarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // ดึงค่าจาก localStorage ถ้าไม่มีให้ default เป็น 'TH'
      lang: localStorage.getItem("lang") || "TH",
    };
  }

  // ฟังก์ชันสำหรับเปลี่ยนภาษา
  changeLanguage = (newLang) => {
    this.setState({ lang: newLang }, () => {
      // บันทึกลง localStorage เมื่อ state เปลี่ยนสำเร็จ
      localStorage.setItem("lang", newLang);

      // ตัวเลือกเสริม: ถ้าต้องการให้หน้าเว็บ Refresh เพื่ออัปเดตภาษาทั้งระบบ
      window.location.reload();
    });
  };

  render() {
    const { lang } = this.state;

    return (
      <div className="btn-group btn-group-sm bg-white rounded-pill shadow-sm border p-1">
        {/* ปุ่มภาษา TH */}
        <button
          className={`btn rounded-pill px-3 py-1 fw-bold border-0 ${
            lang === "TH" ? "btn-primary" : "text-secondary"
          }`}
          style={{ fontSize: "12px" }}
          onClick={() => this.changeLanguage("TH")}
        >
          TH
        </button>

        {/* ปุ่มภาษา EN */}
        <button
          className={`btn rounded-pill px-3 py-1 fw-bold border-0 ${
            lang === "EN" ? "btn-primary" : "text-secondary"
          }`}
          style={{ fontSize: "12px" }}
          onClick={() => this.changeLanguage("EN")}
        >
          EN
        </button>
      </div>
    );
  }
}
